import BenefitHeroImg from "../../../../assets/affiliates/benefitHeroImg.png";
import ArrowDownIcon from "../../../../assets/affiliates/arrowDown.svg";
import { Theme, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useElementHeight } from "../../hooks/useElementHeight";
import { BenefitBlockMobile } from "../benefitProgram/BenefitBlockMobile";
import { BenefitBlock } from "../benefitProgram/BenefitBlock";
import { benefitsData } from "../../constants";

export const BenefitProgramSection = ({
  howToJoinRef,
}: {
  howToJoinRef: React.RefObject<HTMLDivElement>;
}) => {
  const { t, i18n } = useTranslation(["affiliates"]);
  const isRTL = i18n.dir() === "rtl";
  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const { elementRef, height } = useElementHeight();

  const handleClickScrollToNextSection = () => {
    if (howToJoinRef.current) {
      howToJoinRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div
      style={{
        marginTop: downMd ? "50px" : "110px",
        marginBottom: downMd ? "350px" : "147px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div
        className="benefit-title-container"
        style={{
          fontSize: downMd ? "24px" : "34px",
          lineHeight: downMd ? "24px" : "46px",
          marginBottom: downMd ? "30px" : "46px",
          fontFamily: isRTL ? "Noto Sans Hebrew" : "Frank Ruhl Libre",
        }}
      >
        {isRTL ? (
          <div className="benefit-rtl-title-container">
            <div className="benefit-rtl-title-container-inner">
              <div>{t("benefit_title1")}</div>
              <div className="benefit-title-grey-container">
                {t("benefits")}
              </div>
            </div>

            <div>{t("benefit_title2")}</div>
          </div>
        ) : (
          <div
            className="benefit-ltr-title-container"
            style={{
              flexDirection: downMd ? "column" : "row",
            }}
          >
            <div className="benefit-ltr-title">{t("benefit_title")}</div>
            <div className="benefit-title-grey-container">{t("benefits")}</div>
          </div>
        )}
      </div>

      {downMd ? (
        <div className="benefit-mobile-container" ref={elementRef}>
          <img src={BenefitHeroImg} className="benefit-mobile-img" />
          <div
            className="benefit-program-mobile-el-container"
            style={{
              top: `${height - 30}px`,
            }}
          >
            {benefitsData.map((benefit, index) => (
              <BenefitBlockMobile
                benefitText={benefit.benefitText}
                key={index}
              />
            ))}
          </div>
        </div>
      ) : (
        <div
          style={{
            padding: "0 160px",
          }}
        >
          <div
            style={{
              position: "relative",
            }}
          >
            <img
              src={BenefitHeroImg}
              style={{ maxWidth: "881px", width: "100%" }}
            />

            <div
              className="arrow-down-container"
              onClick={handleClickScrollToNextSection}
            >
              <img src={ArrowDownIcon} alt="arrow-down" />
            </div>

            {benefitsData.map((benefit, index) => (
              <BenefitBlock
                key={index}
                benefitText={benefit.benefitText}
                positionTop={benefit.positionTop}
                positionRight={benefit.positionRight}
                positionLeft={benefit.positionLeft}
                maxWidth={benefit.maxWidth}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
